import { fetchApi, getFetchApiJSONResponse, catchFetchApiError } from 'shared/functions';

export const fetchProducts = () =>
  fetchApi('/shop/subscriptions/')
    .then(getFetchApiJSONResponse)
    .catch(catchFetchApiError);

export const changeProductsFavoriteStatus = ({ ids, isFavorite }) =>
  fetchApi('/shop/subscriptions-history/', {
    method: isFavorite ? 'POST' : 'DELETE',
    body: JSON.stringify({ favorites: ids }),
  });

export const fetchShopHistory = () =>
  fetchApi('/shop/subscriptions-history/')
    .then(getFetchApiJSONResponse)
    .catch(catchFetchApiError);

export const addProductsToBasket = ({ ids }) =>
  fetchApi('/shop/subscriptions-history/', {
    method: 'POST',
    body: JSON.stringify({ basket: ids }),
  });

export const removeProductsFromBasket = ({ ids }) =>
  fetchApi('/shop/subscriptions-history/', {
    method: 'DELETE',
    body: JSON.stringify({ basket: ids }),
  });

export const createProduct = product =>
  fetchApi(
    '/shop/save-product/',
    {
      method: 'POST',
      body: product,
    },
    ['Content-Type'],
  )
    .then(getFetchApiJSONResponse)
    .catch(catchFetchApiError);

export const fetchProductProperties = () =>
  fetchApi('/shop/dictionaries/')
    .then(getFetchApiJSONResponse)
    .catch(catchFetchApiError);

export const createProductThirdPartySource = source =>
  fetchApi(
    '/shop/create-source/',
    {
      method: 'POST',
      body: source,
    },
    ['Content-Type'],
  );

export const acceptTermsAndConditions = data =>
  fetchApi('/shop/tcacknowledgement-create/', {
    method: 'POST',
    body: JSON.stringify(data),
  })
    .then(getFetchApiJSONResponse)
    .catch(catchFetchApiError);

export const purchaseProducts = data =>
  fetchApi('/shop/purchase-products/', {
    method: 'POST',
    body: JSON.stringify(data),
  })
    .then(getFetchApiJSONResponse)
    .catch(catchFetchApiError);

export const sendMessageToSales = data =>
  fetchApi('/shop/contact-sales/', {
    method: 'POST',
    body: JSON.stringify(data),
  })
    .then(getFetchApiJSONResponse)
    .catch(catchFetchApiError);

export const startFreeTrial = data =>
  fetchApi('/shop/free-trial-confirmation/', {
    method: 'POST',
    body: JSON.stringify(data),
  })
    .then(getFetchApiJSONResponse)
    .catch(catchFetchApiError);

export const startFreeSubscription = data =>
  fetchApi('/shop/free-of-charge-confirmation/', {
    method: 'POST',
    body: JSON.stringify(data),
  })
    .then(getFetchApiJSONResponse)
    .catch(catchFetchApiError);

export const duplicateShopProducts = data =>
  fetchApi('/shop/duplicate-products/', {
    method: 'POST',
    body: JSON.stringify(data),
  })
    .then(getFetchApiJSONResponse)
    .catch(catchFetchApiError);

export const cancelSubscriptions = data =>
  fetchApi('/shop/cancel-subscriptions/', {
    method: 'POST',
    body: JSON.stringify(data),
  })
    .then(getFetchApiJSONResponse)
    .catch(catchFetchApiError);

export const activateSubscriptions = data =>
  fetchApi('/shop/subscriptions-reactivate/', {
    method: 'POST',
    body: JSON.stringify(data),
  })
    .then(getFetchApiJSONResponse)
    .catch(catchFetchApiError);

export const deleteSubscriptions = data =>
  fetchApi('/shop/delete-products/', {
    method: 'POST',
    body: JSON.stringify(data),
  })
    .then(getFetchApiJSONResponse)
    .catch(catchFetchApiError);

export const fetchShopPermissions = () =>
  fetchApi('/shop/permissions/')
    .then(getFetchApiJSONResponse)
    .catch(catchFetchApiError);

export const fetchShopRelatedSubscriptions = data =>
  fetchApi('/shop/subscriptions-filtered/', {
    method: 'POST',
    body: JSON.stringify(data),
  })
    .then(getFetchApiJSONResponse)
    .catch(catchFetchApiError);
